"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _batcher = _interopRequireDefault(require("./batcher"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

var ClientMetricsBatcher = _batcher.default.extend({
  namespace: 'Metrics',
  prepareItem: function prepareItem(item) {
    // Add more defaults to payload when the clientmetrics endpoint evolves to support richer payloads
    return _promise.default.resolve(item);
  },
  prepareRequest: function prepareRequest(queue) {
    return _promise.default.resolve(queue);
  },
  submitHttpRequest: function submitHttpRequest(payload) {
    return this.webex.request({
      method: 'POST',
      service: 'metrics',
      resource: 'clientmetrics',
      body: {
        metrics: payload
      }
    });
  }
});
var _default = ClientMetricsBatcher;
exports.default = _default;
//# sourceMappingURL=client-metrics-batcher.js.map
